import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Modal, Button } from "react-bootstrap";
import ItineraryHeader from "../common/ItineraryHeader";
import TimelineComponent from "../common/TimelineComponent";
import itineraryData from "../../data/data.json";
import updatedData from "../../data/updatedData.json";
import ExpandedActivityCard from "../common/ExpandedActivityCard";
import ChatBubble from "../common/chatBubble";
import { getGeolocation } from "../../_utils/getGeolocation";
import { FAQS } from "../../_utils/constant";
import FAQModal from "../../_modals/specific/FAQModal";
import { calculateEndTime } from "../../_utils/formatTime";
import { ActivitiesContext } from "../../context/ActivitiesContext";
import LateActivityModal from "../../_modals/specific/LateActivityModal";
import AllLocationsMapModal from "../../_modals/specific/AllLocationsMapModal";
import ScenarioSimulator from "../../_modals/specific/ScenarioSimulator";




const DayItineraryUpdated = ({ dayNumber, tier, planId }) => {
    const { activities, changeAllActivities, processedActivities, removedActivities, newActivities } = useContext(ActivitiesContext);
    // console.log("Activities Context = ", newActivities);
    const [isUpdated, setIsUpdated] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [showChatBubble, setShowChatBubble] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [modalData, setModalData] = useState({});
    const [currentLocation, setCurrentLocation] = useState("");
    const [currentDay, setCurrentDay] = useState(dayNumber);
    const [geoActivities, setGeoActivities] = useState([]);
    const [updatedPlan, setUpdatedPlan] = useState(null);



    const originalActivities = itineraryData[tier]?.[`Day ${dayNumber}`]?.items || [];
    const updatedActivities = isUpdated
        ? updatedData[`Day ${currentDay}`]?.items || []
        : originalActivities;



    const handleModalClose = () => {
        setShowModal(false);
        setModalType("");
        setModalData({});
    };

    useEffect(() => {
        getGeolocation(setCurrentLocation);
        setTimeout(() => setShowChatBubble(true), 3000);
    }, []);

    const handleModalOpen = (type, data = {}) => {
        setModalType(type);
        setModalData(data);
        setShowModal(true);
    };

    const handleHelpClick = () => {
        handleModalOpen("faq", { faqs: FAQS });
    };

    const formatTo24Hour = (timeString) => {
        if (!timeString) return "";

        // Match time like "3:00 PM" or "12:30 am"
        const amPmRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i;
        const match = timeString.match(amPmRegex);

        if (match) {
            let [_, hour, minute, ampm] = match;
            hour = parseInt(hour, 10);
            if (ampm.toUpperCase() === "PM" && hour !== 12) hour += 12;
            if (ampm.toUpperCase() === "AM" && hour === 12) hour = 0;
            return `${hour.toString().padStart(2, "0")}:${minute}`;
        }

        // If already in 24-hour or ISO, let Date parse
        const date = new Date(timeString);
        if (!isNaN(date.getTime())) {
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        }

        return timeString; // fallback
    };


    const handlePlanChange = (newActivity) => {
        console.log("Received newActivity:", newActivity);

        if (newActivity.multi_day_itinerary) {
            const normalizedPlan = newActivity.multi_day_itinerary.map((day, index) => ({
                ...day,
                items: (day.plan || []).map((activity, idx) => {
                    console.log("Received start time:", activity.start_time);
                    return {
                        ...activity,
                        start_time: formatTo24Hour(activity.start_time || `${day.date}T09:00:00`),
                        end_time: formatTo24Hour(activity.end_time || `${day.date}T10:00:00`),
                        name: activity.location || `Activity ${idx + 1}`,

                        end_time: activity.end_time || `${day.date}T10:00:00`,

                    };
                }),
            }));
            if (changeAllActivities) {
                changeAllActivities(normalizedPlan); // <- this updates global context
            }

            // setUpdatedPlan(normalizedPlan);
            // setIsUpdated(true);
        } else {
            console.warn("Missing multi_day_itinerary in newActivity");
        }

        setShowModal(false);
        setModalType("");
        setModalData({});
    };



    useEffect(() => {
        const fetchCoordinates = async () => {
            try {
                const activitiesList = processedActivities(currentDay - 1);

                const promises = activitiesList.map(async (activity, index) => {
                    // console.log(`Fetching coordinates for Activity ${index + 1}:`, activity.place_id);

                    if (!activity.place_id) return null;

                    try {
                        const response = await fetch(
                            `https://citygetaway-backend-plan-service.vercel.app/api/place_lat_lng?place_id=${activity.place_id}`,
                            {
                                headers: {
                                    "X-User-Name": "testDan",
                                    "X-User-Id": "681a6db71771cb427864f564",
                                },
                            }
                        );

                        if (!response.ok) {
                            console.error(`Failed to fetch for ${activity.place_id}:`, response.statusText);
                            return null;
                        }

                        const data = await response.json();

                        if (data?.lat && data?.lng) {
                            return {
                                ...activity,
                                lat: data.lat,
                                lng: data.lng,
                            };
                        } else {
                            console.warn(`No lat/lng for activity with place_id ${activity.place_id}`);
                            return null;
                        }
                    } catch (err) {
                        console.error(`Error fetching coordinates for ${activity.place_id}:`, err);
                        return null;
                    }
                });

                const results = await Promise.all(promises);
                const filtered = results.filter(Boolean);
                setGeoActivities(filtered);
            } catch (error) {
                console.error("Error in fetchCoordinates:", error);
            }
        };

        fetchCoordinates();
    }, [currentDay, processedActivities]);
    console.log("day", currentDay);


    const firstActivity =
        dayNumber === 1
            ? {
                name: "Travelodge Hotel by Wyndham Montreal Center",
                address: "50 Boul. René-Lévesque West, Montreal, QC H2Z 1A2",
                checkIn: "After 3:00 PM",
                description:
                    "Please check in at Travelodge Hotel by Wyndham Montreal Center! Share your arrival method and time, and we'll guide you to reach effortlessly.",
                image: "/assets/chrome.jpg",
            }
            : null;
    const getCurrentDayActivities = () => {
        return processedActivities(currentDay - 1);
    };
    // const getCurrentDayActivities = () => {
    //   if (isUpdated && updatedPlan) {
    //     return updatedPlan[currentDay - 1]?.items || [];
    //   }
    //   return processedActivities(currentDay - 1);
    // };





    return (
        <div>
            <ItineraryHeader
                activeDay={currentDay}
                onDayChange={setCurrentDay}
                totalDays={activities?.length}
                onMapClick={() => setShowMapModal(true)}
            />


            <AllLocationsMapModal
                show={showMapModal}
                onHide={() => setShowMapModal(false)}
                activities={geoActivities}
                day={currentDay}
            />



            <Container>
                {currentDay === 1 && firstActivity && (
                    <Row className="mt-4">
                        <Col md={12} className="mb-4">
                            <ExpandedActivityCard data={firstActivity} />
                        </Col>
                    </Row>)}


                {activities?.length > 0 && (
                    <TimelineComponent
                        // activities={processedActivities(currentDay-1)}
                        activities={getCurrentDayActivities()}
                        removedActivities={removedActivities}
                        newActivities={newActivities}
                        day_index={currentDay - 1}
                        setModalType={setModalType}
                        setModalData={setModalData}
                        setShowModal={setShowModal}
                    />
                )}
            </Container>

            <ChatBubble
                showBubble={showChatBubble}
                message="Need help? Click here for FAQs or updates!"
                onClick={() => handleModalOpen("helpOptions")}
            />


            {modalType === "faq" && <FAQModal show={showModal} onHide={handleModalClose} faqs={modalData.faqs} />}
            {modalType === "lateItinerary" && (
                <LateActivityModal
                    show={showModal}
                    onHide={handleModalClose}
                    handleUpdate={() => setIsUpdated(true)}
                    modalData={modalData}
                    // updatedItinerary={updatedActivities}
                    updatedItinerary={modalData?.multi_day_itinerary || []}
                // onPlanChanged={handlePlanChange}
                />
            )}
            {modalType === "helpOptions" && (
                <Modal show={showModal} onHide={handleModalClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Need Help?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>What would you like to do?</p>
                        <div className="d-grid gap-2">
                            <Button
                                variant="primary"
                                onClick={() => {
                                    handleModalOpen("faq", { faqs: FAQS });
                                }}
                            >
                                📘 View FAQs
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    // Close the helpOptions modal
                                    handleModalClose();

                                    // Wait a bit, then open the Scenario modal
                                    setTimeout(() => {
                                        setModalType("scenario");
                                        setModalData({ day: currentDay });
                                        setShowModal(true);
                                    }, 300); // Give React enough time to unmount the helpOptions modal
                                }}
                            >
                                🧪 Simulate Scenario
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}


            {modalType === "scenario" && showModal && (
                <ScenarioSimulator
                    show={true}
                    onHide={handleModalClose}
                    dayNumber={modalData.day}
                    onPlanChanged={handlePlanChange}
                />
            )}



        </div>
    );
};

export default DayItineraryUpdated;